import { render, staticRenderFns } from "./TeamOffice.vue?vue&type=template&id=2ece1d60&scoped=true&"
import script from "./TeamOffice.vue?vue&type=script&lang=js&"
export * from "./TeamOffice.vue?vue&type=script&lang=js&"
import style0 from "./TeamOffice.vue?vue&type=style&index=0&id=2ece1d60&lang=scss&scoped=true&"
import style1 from "./TeamOffice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece1d60",
  null
  
)

export default component.exports